<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-16 12:02:05
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-17 15:44:46
 * @FilePath: \zhucai_user\src\pages\member\child\info.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="my-container">
    <div class="my-title">开票</div>
    <div class="my-content">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="150px"
        class="my-form"
      >
        <el-form-item label="发票类型：" prop="InvoiceType">
          <el-select
            v-model="form.InvoiceType"
            :disabled="$route.query.type == 1"
            placeholder="请选择"
            clearable
          >
            <el-option label="个人" :value="1" />
            <el-option label="企业" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="发票抬头：" prop="InvoiceTitle" class="width754">
          <el-input
            placeholder="请输入"
            :disabled="$route.query.type == 1"
            v-model="form.InvoiceTitle"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号：" prop="TaxNumber" class="width754">
          <el-input
            placeholder="请输入"
            :disabled="$route.query.type == 1"
            v-model="form.TaxNumber"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="收件人：" prop="RealName">
          <el-input
            placeholder="请输入"
            :disabled="$route.query.type == 1"
            v-model="form.RealName"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="Phone">
          <el-input
            placeholder="请输入"
            :disabled="$route.query.type == 1"
            v-model="form.Phone"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="邮箱：" prop="Email">
          <el-input
            placeholder="请输入"
            :disabled="$route.query.type == 1"
            v-model="form.Email"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="金额（元）：" prop="InvoiceAmount">
          <div class="InvoiceAmount b600">{{ form.InvoiceAmount }}</div>
        </el-form-item>
        <el-form-item v-if="$route.query.type != 1" label=" " prop="userName">
          <div class="mt30">
            <selectOrder @selectedList="selectedList" />
          </div>
        </el-form-item>
        <el-form-item label="关联订单：" prop="userName">
          <el-table
            v-if="form.InvoiceOrders.length > 0"
            :data="form.InvoiceOrders"
          >
            <el-table-column
              prop="OrdersNo"
              label="订单编号"
              align="center"
              min-width="150"
            />
            <el-table-column
              prop="OrdersTypeTxt"
              label="订单类型"
              align="center"
              width="120"
            />
            <el-table-column
              prop="Title"
              label="商品名称"
              align="center"
              min-width="200"
            />
            <el-table-column
              prop="Price"
              label="实付金额（元）"
              align="center"
              width="150"
            >
            </el-table-column>
            <el-table-column
              prop="AddTime"
              label="下单时间"
              align="center"
              width="200"
            />
            <el-table-column
              v-if="$route.query.type != 1"
              label="操作"
              width="140"
              align="center"
            >
              <template slot-scope="scope">
                <el-button class="table-btn" @click="hanldDel(scope.$index)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label=" ">
          <el-button class="submit-btn" @click="back"> 返回 </el-button>
          <el-button
            v-if="$route.query.type != 1"
            class="submit-btn"
            @click="submit"
          >
            确定
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { GetMyInvoiceDetail, MyInvoice_Apply } from "@/api/member";
import selectOrder from "./child/selectOrder.vue";
import { accAdd } from "@/util/util";
/* eslint-disable */
export default {
  name: "applyInvoicing",
  components: { selectOrder },
  data() {
    return {
      form: {
        InvoiceType: "",
        InvoiceTitle: "",
        TaxNumber: "",
        InvoiceAmount: 0,
        RealName: "",
        Email: "",
        Phone: "",
        InvoiceOrders: [],
      },
      rules: {
        InvoiceType: [
          {
            required: false,
            message: "发票类型不能为空",
            trigger: ["blur", "change"],
          },
        ],
        InvoiceTitle: [
          {
            required: false,
            message: "发票抬头不能为空",
            trigger: ["blur", "change"],
          },
        ],
        TaxNumber: [
          {
            required: false,
            message: "纳税人识别号不能为空",
            trigger: ["blur", "change"],
          },
        ],
        RealName: [
          {
            required: false,
            message: "收件人不能为空",
            trigger: ["blur", "change"],
          },
        ],
        Phone: [
          {
            required: false,
            message: "手机号不能为空",
            trigger: ["blur", "change"],
          },
        ],
        Email: [
          {
            required: false,
            message: "邮箱不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },

  mounted() {
    if (this.$route.query.InvoiceID) {
      this.getInfo();
    }
  },

  methods: {
    hanldDel(index) {
      this.form.InvoiceOrders.splice(index, 1);
    },
    selectedList(val) {
      let Amount = 0;
      this.form.InvoiceOrders = val.map((item) => {
        Amount = accAdd(Amount, item.PayedAmount);
        return item;
      });
      this.form.InvoiceAmount = Amount;
      console.log(this.form.InvoiceOrders);
    },

    submit() {
      const data = {
        ...this.form,
      };
      MyInvoice_Apply(data).then((res) => {
        if (res.code == 0) {
          this.$message.success("申请开票成功");
          this.back();
        } else {
        }
      });
    },
    back() {
      this.$router.push({ path: "/member/billing" });
    },
    getInfo() {
      GetMyInvoiceDetail({
        InvoiceID: this.$route.query.InvoiceID,
      })
        .then((res) => {
          this.form = { ...this.form, ...res.data };
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.InvoiceAmount {
  width: 305px;
  height: 46px;
  padding-left: 15px;
  background: #eceef1;
  border-radius: 6px;
  border: 1px solid #e6e6e6;
  font-weight: bold;
  font-size: 20px;
  color: #333333;
}
.my-form {
  ::v-deep .el-form-item__label {
    width: 150px !important;
  }
  ::v-deep .el-form-item__content {
    margin-left: 150px !important;
  }
  ::v-deep .el-input__inner {
    width: 300px;
    height: 46px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #e6e6e6;
  }
  .width754 {
    ::v-deep .el-input__inner {
      width: 754px;
      height: 46px;
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #e6e6e6;
    }
  }
}
.submit-btn {
  width: 144px;
  height: 52px;
  background: #1d79ff;
  border-radius: 6px;
  font-size: 18px;
  color: #ffffff;
}
.Amount {
  font-weight: bold;
  font-size: 20px;
  color: #e12a14;
}
</style>
